import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip, Pagination } from 'components';
import { QuoteService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';

interface Props {
	onClose?: any;
	item?: any;
}

const INITIAL_STATE = {
	search: ''
}

class EditOperators extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		item_actives: [],
		quotes: []
	}

	async componentDidMount() {
		await this.setState({
			item_actives: this.props.item?.operators?.map((i: any) => i.user_id) || []
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await QuoteService.admin.getOperators({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			quote_id: this.props.item?.id
		});
		this.setState({
			data: res.operators.rows,
			last_page: res.operators.count,
			quotes: res.quotes
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
		await QuoteService.admin.saveOperators({
			quote_id: this.props.item?.id,
			item_actives: this.state.item_actives
		});
		this.props.onClose();
	}

	setActive = (id: number) => {
		let item_actives: any = [...this.state.item_actives];
		const index = item_actives.indexOf(id);
		if (index == -1) {
			item_actives.push(id);
		}
		else {
			item_actives.splice(index,1);
		}
		this.setState({
			item_actives
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		const item_actives: any = this.state.item_actives;
		const quotes: any = this.state.quotes;

		return (
			<div id="modal-quotes-edit-operators">
				<form onSubmit={ this.submit }>
					<div className="container-form">
						<div className="container-operators-count">
							<h3 className="operators-selected">{ item_actives.length } Operario(s) seleccionados</h3>
							{
								item_actives.length > 0 && (
									<p onClick={ () => {
										this.setState({
											item_actives: []
										});
									} } className="reset-operators">Eliminar todos los operarios</p>
								)
							}
						</div>

						<Input
							searchLeft
							value={ this.state.form.search }
							name="search"
							placeholder="Buscar por nombre"
							className="input-table"
							onSubmit={ () => this.load() }
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />

						{
							this.state.data.map((item: any) => {
								const inactive = this.state.quotes.filter((i: any) => {
									return i.status != Constants.QUOTE_STATUS.FINISH && i.status != Constants.QUOTE_STATUS.CANCELLED && i.operators?.map((i: any) => i.user_id).indexOf(item.id) != -1 && (i.journey_id == this.props.item?.journey_id || i.journey?.full_journey == Constants.FULL_JOURNEY || this.props.item?.journey?.full_journey == Constants.FULL_JOURNEY);
								}).length > 0;

								return (
									<div className="item-operator">
										{
											!inactive && (
												<CheckboxTable 
													active={ item_actives.indexOf(item.id) != -1 } 
													onClick={ () => this.setActive(item.id) } />
											)
										}
										<img src={ Constants.BASE_STORAGE + item.photo } />
										<div className="container-text">
											<p className="name">{ item.full_name }</p>
											{ item.services?.length > 0 && <p className="services">{ item.services?.filter((i: any) => i.service?.name).map((i: any) => i.service?.name).join(', ') }</p> }
											<p className={ `status ${ !inactive ? 'green' : 'red' }` }>{ !inactive ? 'Disponible' : 'Ocupado' }</p>
										</div>
									</div>
								)
							})
						}

						{
							this.state.data.length == 0 && (
								<p className="no-data">No se encontraron operarios</p>
							)
						}

						<Pagination 
							pages={ this.state.last_page } 
							active={ this.state.page }
							onChange={ async (page: number) => {
								await this.setState({
									page: page
								});
								this.load();
							} } />
					</div>
					<div className="text-center container-submit">
						<button className="btn" type="submit">
							Guardar
						</button>
					</div>
				</form>
			</div>
		)
	}
}

export default EditOperators;